import GetAppIcon from '@mui/icons-material/GetApp'
import Button from '@mui/material/Button'
import Hidden from '@mui/material/Hidden'
import { useEffect, useState } from 'react'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import useButtonsStyles from '../../../styles/buttonsStyles'
import { generateUrl } from '../../../utils/healthCareService'
import { useLegacyHcs } from '../../legacy/LegacyHcsProvider'

const ImportPatientsButton = () => {
    const buttonsClasses = useButtonsStyles()
    const { id: hcsId, arePatientsInmate } = useCurrentHcs()
    const legacyHcs = useLegacyHcs()
    const [importUrl, setImportUrl] = useState('')

    useEffect(() => {
        ;(async () => {
            const url = encodeURIComponent(await generateUrl(legacyHcs))
            setImportUrl(url)
        })()
    }, [legacyHcs])

    return (
        <Button
            className={buttonsClasses.ButtonTextBlack}
            startIcon={<GetAppIcon />}
            target="_blank"
            href={`${window._env_.REACT_APP_HDS_HOST}/importDb/${hcsId}?homeName=${importUrl}&fromIds=true&patientsAreInmate=${arePatientsInmate}`}
        >
            <Hidden smDown>Importer</Hidden>
        </Button>
    )
}

export default ImportPatientsButton
